// Droit d'écriture sur un projet.
//
// Règle du serveur (`server/src/ingest/guard.js`) : écrire exige d'être admin
// de l'organisation OU **Responsable** du projet visé. Un Contributeur ou un
// Observateur ne peut pas — y compris par un verbe HTTP différent, ce qui a été
// corrigé et verrouillé par des tests côté serveur.
//
// Ce hook ne fait que MASQUER ce qui serait de toute façon refusé : il n'est pas
// la garantie. Proposer un formulaire pour se voir opposer un 403 est une
// mauvaise expérience, pas une faille.
import { useMe } from '../api/queries';

export function useCanWrite(projectId: string): boolean {
  const me = useMe();
  if (!me.data) return false;
  if (me.data.user.orgRole === 'admin') return true;
  return me.data.projectRoles[projectId] === 'Responsable';
}
